/** @jsxRuntime classic */
/** @jsx jsx */
import * as React from 'react';
import { useContext, useState, useEffect } from 'react';

// oxlint-disable-next-line no-unused-vars
import { jsx } from '@emotion/core';

import { mediaMaxWidthMedium } from '~/components/shared/viewPorts';
import BannerContext from '~/contexts/BannerContext';
import { styled } from '~/styled';

export const SidebarWrap = styled.div(({ theme }) => {
  return `
  flex: 0 0 260px;
  ${mediaMaxWidthMedium} {
    display: none;
  }
  padding-top: ${theme.space.space32};
  background-color: ${theme.colors.n40};
  border-right: 1px solid ${theme.colors.n80};
`;
});

type SidebarProps = {
  offsetBanner: boolean;
  top: number;
};

export const SidebarSectionList = styled.ul<SidebarProps>(({ top, theme }) => {
  return `
  margin-top: 0px;
  margin-bottom: 0px;
  padding-right: ${theme.space.space16};
  padding-left: 18px;
  list-style: none;
  position: sticky;
  top: ${top}px;
  align-self: start;
  width: 260px;
  height: calc(100vh - ${top}px);
  overflow-y: auto;
  overflow-wrap: break-word;
  transition: top 250ms ease-out;

  .banner-closing & {
    top: 168px;
  }
`;
});

export const SidebarSectionHeading = styled.a(({ theme }) => {
  return `
  color: ${theme.colors.n700};
  &:visited {
    color: ${theme.colors.n700};
  }
  font-size: ${theme.space.space16};
  font-weight: ${theme.fontWeights.bold};
  letter-spacing: 0.1px;
  line-height: ${theme.space.space24};
  text-decoration: none;
  margin-bottom: ${theme.space.space8};
  margin-top: 0px;
  display: block;
`;
});

export const SidebarSubSectionList = styled.ul(({ theme }) => {
  return `
  margin-bottom: ${theme.space.space12};
  list-style: none;
  padding-left: 0px;
`;
});

export const SidebarSubSectionItem = styled.li(({ theme }) => {
  return `
  line-height: ${theme.space.space24};
  margin-bottom: ${theme.space.space8};
`;
});

export const SidebarSubSectionLink = styled.a(({ theme }) => {
  return `
  color: ${theme.colors.n400};
  text-decoration: none;
  display: block;
`;
});

export const SidebarSectionItem = styled.li(({ theme }) => {
  return `
  margin-bottom: ${theme.space.space20};
`;
});

const SidebarContainer = ({ children }: { children: React.ReactNode }) => {
  const { showCurrentBanner, isBannerClosing } = useContext(BannerContext);
  const top = showCurrentBanner ? 214 : 168;

  /* When included in the image details page, this gets
  rendered server-side and this causes issues in updating CSS styles
  client-side, so we need to update the key to get the styles to be refreshed */
  const [isClient, setClient] = useState(false);
  useEffect(() => {
    setClient(true);
  }, []);
  const key = isClient ? `client` : `server`;

  return (
    <SidebarWrap className={isBannerClosing ? 'banner-closing' : null}>
      <SidebarSectionList key={key} offsetBanner={showCurrentBanner} top={top}>
        {children}
      </SidebarSectionList>
    </SidebarWrap>
  );
};

export default SidebarContainer;
